const javascriptBridge = {
  startScan,
  stopScan,
  getDeviceInfo,
  ssoUrl,
  getLocationInfo,
  outLink,
  hanaLink,
  searchUrl,
  testNfc,
  pushAuth,
  pushInfo,
  idCard,
  brightEnable,
  brightDisable,
  notchEnable,
  notchDisable,
  bottomNotch,
  kakaoLogin,
  naverLogin,
  naverLogout,
  accessInit,
  accessMypage,
  startNfc,
  activeBle,
  logoutMobile,
  showToast,
  deepLink,
}

function startScan(beacon) {
  var ua = navigator.userAgent.toLowerCase()

  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.startScan(JSON.stringify(beacon))
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.startScan.postMessage(JSON.stringify(beacon))
  }
}

function stopScan() {
  var ua = navigator.userAgent.toLowerCase()

  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('stopScan')
  }
}

function getDeviceInfo() {
  // 해당 단말기가 무엇인지 확인 ( ex : android, iphone, safari, chrome ... )
  var ua = navigator.userAgent.toLowerCase()

  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    if (window.ANDROID && typeof window.ANDROID.getDeviceInfo === 'function') {
      ANDROID.getDeviceInfo()
    }
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.scriptHandler
    ) {
      window.webkit.messageHandlers.scriptHandler.postMessage('getDeviceInfo')
    } else {
      console.log('개발중 webkit오류 무시')
    }
  } else {
    // alert('비정상정인 접근입니다. \n홈페이지로 이동합니다.')
    // location.href = 'https://www.khu.ac.kr'
  }
}

// sso
function ssoUrl(token, deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.ssoUrl(JSON.stringify(token))
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    window.webkit.messageHandlers.ssoUrl.postMessage(JSON.stringify(token))
  }
}

function getLocationInfo(deviceOs) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    if (window.ANDROID && typeof window.ANDROID.getDeviceInfo === 'function') {
      ANDROID.getLocationInfo()
    }
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('getLocationInfo')
  }
}

function outLink(urlInfo, deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.searchUrl(JSON.stringify(urlInfo))
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    window.webkit.messageHandlers.searchUrl.postMessage(JSON.stringify(urlInfo))
  }
}

// idcard의 하나페이 링크 연결
function hanaLink(urlInfo) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.searchUrl(JSON.stringify(urlInfo))
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.hanaLink.postMessage(JSON.stringify(urlInfo))
  }
}

// 통합검색
function searchUrl(searchInfo, deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.searchUrl(JSON.stringify(searchInfo))
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    window.webkit.messageHandlers.searchUrl.postMessage(
      JSON.stringify(searchInfo)
    )
  }
}

function testNfc(deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.testNfc()
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    webkit.messageHandlers.scriptHandler.postMessage('testNfc')
  }
}

// 시스템 알림 설정 이동
function pushAuth(deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.pushAuth()
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    webkit.messageHandlers.scriptHandler.postMessage('pushAuth')
  }
}

// 시스템 알림 설정 확인
function pushInfo() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    if (window.ANDROID && typeof window.ANDROID.getDeviceInfo === 'function') {
      ANDROID.pushInfo()
    }
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.scriptHandler
    ) {
      window.webkit.messageHandlers.scriptHandler.postMessage('pushInfo')
    }
  } else {
    // alert('비정상정인 접근입니다. \n홈페이지로 이동합니다.')
    // location.href = 'https://www.khu.ac.kr'
  }
}

function idCard(deviceOs) {
  // 안드로이드일 경우
  if (deviceOs === 'ANDROID') {
    ANDROID.idCard()
    // iOS인 경우
  } else if (deviceOs === 'IOS') {
    webkit.messageHandlers.scriptHandler.postMessage('idCard')
  }
}

// 화면 밝기 최대 요청
function brightEnable() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.brightEnable()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('brightEnable')
  }
}

// 화면 밝기 원래대로 요청
function brightDisable() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.brightDisable()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('brightDisable')
  }
}

function notchEnable() {
  var ua = navigator.userAgent.toLowerCase()
  if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('notchEnable')
  }
}

function bottomNotch() {
  var ua = navigator.userAgent.toLowerCase()
  if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('bottomNotch')
  }
}

// 아이폰 노치 초기화
function notchDisable() {
  var ua = navigator.userAgent.toLowerCase()
  if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    webkit.messageHandlers.scriptHandler.postMessage('notchDisable')
  }
}

// sns로그인 버튼 클릭
function kakaoLogin() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.kakaoLogin()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.scriptHandler.postMessage('kakaoLogin')
  }
}

// sns 네이버 로그인
function naverLogin() {
  // btn.click()
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.naverLogin()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.scriptHandler.postMessage('naverLogin')
  }
}

// 네이버 로그인 해제 시 네이버 로그아웃
function naverLogout() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.cancelSns()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.scriptHandler.postMessage('cancelSns')
  }
}

// 출입에 대한 권한요청 (로그인 출입변경)
function accessInit(userInfo, userAccess) {
  const accessInfo = {
    userAccess: userAccess,
    userPhone: userInfo.userPhone,
    userIdno: userInfo.userIdno,
  }

  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.NFC_INIT(JSON.stringify(accessInfo))
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.BLE_INIT.postMessage(
      JSON.stringify(accessInfo)
    )
  }
}

// 출입에 대한 초기화 SK (마이페이지 출입변경)
function accessMypage(initInfo) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.NFC_INIT(JSON.stringify(initInfo))
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.BLE_INIT.postMessage(JSON.stringify(initInfo))
  }
}

// 출입에 대한 권한요청 (마이페이지 출입변경 - 안드로이드 nfc 실행)
function startNfc(accessInfo) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.NFC_START(JSON.stringify(accessInfo))
  }
}

// 아이폰 ble 활성화 (10초)
// userAccess, userIdno
function activeBle(accessInfo) {
  var ua = navigator.userAgent.toLowerCase()

  if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.BLE_START.postMessage(
      JSON.stringify(accessInfo)
    )
  }
}

// 로그아웃으로 인한 출입해제
function logoutMobile() {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.NFC_STOP()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.scriptHandler.postMessage('BLE_STOP')
  }
}

// 아이폰 토스트 요청
function showToast(text) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    // ANDROID.STOP_NFC()
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.toastHandler.postMessage(text)
  }
}

// 딥링크 이동
function deepLink(appName) {
  var ua = navigator.userAgent.toLowerCase()
  // 안드로이드일 경우
  if (ua.indexOf('android') > -1) {
    ANDROID.RUN_APP(appName)
    // iOS인 경우
  } else if (
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    ua.indexOf('ipod') > -1
  ) {
    window.webkit.messageHandlers.RUN_APP.postMessage(appName)
  }
}

export default javascriptBridge
